<template>
  <div class="pre-bids-list tab-table p-2">
    <PreBidsTable/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import PreBidsTable from "../../../pre-bids/PreBidsTable";

  const {mapState} = createNamespacedHelpers('sales');
  const {mapActions: preBidsMapActions} = createNamespacedHelpers('preBids');

  export default {
    name: "PreBidsList",
    components: {PreBidsTable},
    computed: {
      ...mapState({
        sale: state => state.view.currentSale
      })
    },
    methods: {
      ...preBidsMapActions(['updateTableSource'])
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'sale',
        extraFilters: {auction_uuid: this.sale.uuid},
        sale: this.sale
      });
    }
  }
</script>

<style lang="scss" scoped>
</style>
